<template>
  <Form ref='editAudienceForm'
  editMode></Form>
</template>

<script>
import Form from "@views/admin/emails/Audiences/Form";
export default {
  name: "EditAudience",
  components: {Form},
  async mounted() {
    this.startLoading();
    const audience_id = this.$route.params.id;
    const { data } = await axios.get(`/api/app-http-services/services/notifications/email/audiences/${audience_id}`)
    this.$refs.editAudienceForm.audience = data;
    this.stopLoading();
  }
}
</script>
